<div class="not-found-container">
          <div class="content">
            <div class="error-code">404</div>
            <h1 class="error-title">Oops! Page Not Found</h1>
            <p class="error-message">
              The page you're looking for doesn't exist.
            </p>
            <button routerLink="/" class="home-button">Go Back Home</button>
          </div>
         
        </div>